module.exports = __webpack_public_path__ + "static/media/sound-from-kitchen.0e679e3f.mp3";